var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 125 77", fill: "none" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#a)" },
      React.createElement("path", { fill: "#11BB9A", d: "M0 0h125v77H0z" }),
      React.createElement("path", { d: "M62.538 14l26.448 20.04H36.09L62.538 14zM35.817 58.535h53.442v5.09H35.817zM43.452 54.718V38.176h6.362v16.542zM59.994 54.718V38.176h6.362v16.542zM75.263 54.718V38.176h6.362v16.542z", fill: "#fff" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h125v77H0z" })
      )
    )
  );
});